import { createAsyncThunk } from '@reduxjs/toolkit'
import { GetAllMedicalConditions } from '@services/api/medical-condition.api'
import type { MedicalCondition } from '@dataTypes/allergy-medical-condition.types'

type MedicalConditionCatalogSliceState = {
  medicalConditionsLoading: boolean
  medicalConditionsLoaded: boolean
}

export const fetchMedicalConditionsCatalog = createAsyncThunk<
  MedicalCondition[],
  void,
  { state: { allergyMedicalCondition: MedicalConditionCatalogSliceState } }
>(
  'allergyMedicalCondition/fetchMedicalConditionsCatalog',
  async () => {
    return GetAllMedicalConditions()
  },
  {
    condition: (_, { getState }) => {
      const { medicalConditionsLoading, medicalConditionsLoaded } =
        getState().allergyMedicalCondition
      if (medicalConditionsLoading || medicalConditionsLoaded) return false
      return true
    },
  },
)
